import { portaalQueryOptions } from '@connected/portaal-sdk/queries/options';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CustomerReportContent } from '@/components/customer-reports-content';
import { ObservationLogs } from '@/components/logbook-observations';

export const Route = createFileRoute(
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/$observationId/',
)({
    component: RouteComponent,
});

export function RouteComponent() {
    const params = Route.useParams();

    const { data: installationData } = useQuery(portaalQueryOptions.electrical.distributionBoards.view({
        ElectricalProjectDistributionBoardId: params.distributionId,
    }));

    if (!installationData?.DistributionBoard) {
        return null;
    }

    return (
        <div>
            <CustomerReportContent
                query={{ ElectricalProjectObservationId: params.observationId }}
                installation={installationData?.DistributionBoard}
            />
            <div className="w-full mt-5">
                <ObservationLogs observationId={params.observationId} projectType="electrical" projectId={params.projectId} />
            </div>
        </div>

    );
}
